import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiFetch, ApiError } from "../api/client";
import { membersKey } from "../api/hooks/useMembers";
import { workspaceKey } from "../api/hooks/useWorkspace";
import { WORKSPACES_KEY } from "../api/hooks/useWorkspaces";

export function useRemoveMember(slug: string) {
  const qc = useQueryClient();
  return useMutation<void, ApiError, string>({
    mutationFn: (userId: string) =>
      apiFetch<void>(`/api/ws/${slug}/members/${userId}`, { method: "DELETE" }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: membersKey(slug) });
      // Removing yourself changes your access — refresh the workspace (owner gate)
      // and the switcher list, which no longer includes it (bugloop L1).
      qc.invalidateQueries({ queryKey: workspaceKey(slug) });
      qc.invalidateQueries({ queryKey: WORKSPACES_KEY });
    },
  });
}
